import { Input, Select } from 'antd';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
  width: 100%;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
`;

export const Wrapper = styled.div`
  padding-bottom: 60px;
`;

export const LabelWrapper = styled.span`
  display: block;
  width: 100%;
`;
